var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_43128)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#paint0_linear_1258_43128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8897 9.75417L10.223 10.1963L10.0921 10.782L10.8135 10.908C11.2828 11.0165 11.3761 11.1787 11.2743 11.6302L10.0921 16.97C9.78289 18.3502 10.2618 19 11.3858 19C12.2588 19 13.2701 18.6127 13.7296 18.0795L13.8703 17.439C13.5514 17.7097 13.0821 17.8182 12.7729 17.8182C12.3328 17.8182 12.174 17.5207 12.2855 16.9968L13.8897 9.75417ZM14 6.54C14 6.94843 13.8314 7.34014 13.5312 7.62894C13.2311 7.91775 12.824 8.08 12.3995 8.08C11.975 8.08 11.5679 7.91775 11.2678 7.62894C10.9676 7.34014 10.799 6.94843 10.799 6.54C10.799 6.13157 10.9676 5.73986 11.2678 5.45106C11.5679 5.16225 11.975 5 12.3995 5C12.824 5 13.2311 5.16225 13.5312 5.45106C13.8314 5.73986 14 6.13157 14 6.54Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1258_43128",
    x1: 0,
    y1: 0,
    x2: 24.6865,
    y2: 23.2717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_43128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoImg);
export default __webpack_public_path__ + "static/media/info-img.dcf4c3673973c6db19055116ce6b9db9.svg";
export { ForwardRef as ReactComponent };